import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import styles from "./components.module.scss";

const EducationAssetRequirement = ({
  uniqueKey = "",
  data = null,
  eligibilityData = null,
  handleChange,
}) => {
  const cardView3and4Details = (ele, option, index) => {
    return (
      <Box
        key={index}
        sx={{
          width: "calc((100% - 195px) / 3)",
        }}
        className={`${styles.textBoxView} ${
          ele.isDisabled ? styles.textBoxViewDisable : ""
        }`}
      >
        <FormControlLabel
          value={option?.id}
          label={option?.name}
          checked={
            ele.type === "radio"
              ? option?.id === eligibilityData[ele.valueKey]?.id
              : option?.id ===
                eligibilityData[ele.valueKey]?.filter(
                  (e) => e.id === option?.id
                )[0]?.id
          }
          sx={{
            width: "100%",
            "& .MuiFormControlLabel-label": {
              fontSize: "14px",
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
            "& .MuiRadio-root, & .MuiCheckbox-root": {
              padding: "0 14px 0 0",
            },
          }}
          control={
            ele.type === "radio" ? (
              <Radio size="small" color="primary" />
            ) : (
              <Checkbox color="primary" />
            )
          }
          onChange={(e) =>
            uniqueKey === "eligibilityCriteria"
              ? handleChange(e, ele.id, option)
              : ""
          }
          disabled={ele.isDisabled}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "30px",
        width: "100%",
      }}
    >
      <Typography
        className={`${styles.formFont} flexDisplayColumn`}
        style={{ rowGap: "17px", alignItems: "flex-start" }}
      >
        <span className="fontWeight500">{data.title}</span>
        <span className={`${styles.greydedText}`} style={{ fontSize: "14px" }}>
          {data.placeHolder}
        </span>
      </Typography>
      {data.type === "radio" ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            rowGap: "30px",
            columnGap: "24px",
          }}
        >
          {data.list?.map((option, index) =>
            cardView3and4Details(data, option, index)
          )}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            rowGap: "30px",
            columnGap: "24px",
          }}
        >
          {data.list?.map((option, index) =>
            cardView3and4Details(data, option, index)
          )}
        </Box>
      )}
    </Box>
  );
};

export default EducationAssetRequirement;
